import React from "react";
import { styled } from "../../../../../stitches.config";
import CompletedProject from "../CompletedProject";
import { observer } from "mobx-react";
import { useStores } from "../../../../../helpers/useStores";

import { ICompletedProject } from "../BridCompletedProjects";
import Heading from "../../../../../redesign/atoms/Heading";

import ArrowIcons from "../../../../../assets/img/left.svg";
import Footer from "../../../../../redesign/components/Footer";

const PaymentSuccess: React.FC = observer(() => {
  const { ArticleStore } = useStores();
  const bridStatus = window?.APP_SETTINGS?.bridStatus || {};

  const {
    article: { brid_other_articles },
  }: { article: { brid_other_articles: Array<ICompletedProject> } } =
    ArticleStore;
  return (
    <Success>
      <SuccessWrap>
        {/* <WrapperContent>
          <Header>
            <span>{bridStatus.Name},</span> Dziękujemy za wpłatę!
          </Header>
          <p>
            Transakcja przebiegła pomyślnie. Informacje o przebiegu zbiórki będą
            wysyłane na <strong>{bridStatus.Mail}</strong>. Jako sponsor
            projektu otrzymasz dostęp do materiału wcześniej niż inni!
          </p>
          <FooterMsg>
            Wyczekuj wiadomości!<span>Ekipa NaTemat</span>
          </FooterMsg>
       </WrapperContent> */}
        <SimilarProjectsWrap className="similar-projects-wrap">
          <Heading
            title="Zrealizowane projekty"
            specialHeading
            specialHeadingStyle="fullDots"
          />
          <WrapperProjects className="payment-success-wrapper-projects">
            {brid_other_articles.map((props, index) => (
              <CompletedProject key={index} {...props} />
            ))}
          </WrapperProjects>
        </SimilarProjectsWrap>
      </SuccessWrap>
      <Footer />
    </Success>
  );
});

const Success = styled("div", {
  width: "100%",
  height: "100vh",
  position: "relative",
  backgroundColor: "#fff",
  zIndex: 5000000,
  paddingBottom: "40px",
  "@bp4": {
    paddingBottom: "0px"
  }
});

const SuccessWrap = styled("div", {
  "h2": {
    marginTop: "25px",
    fontSize: "30px",
    textAlign: "center",
    color: "#ff6e00"
  },
  "p": {
    margin: "10px auto",
    width: "80%",
    fontSize: "16px",
    textAlign: "center",
    color: "#333333"
  },
  "h3": {
    margin: "38px auto 0 auto",
    height: "24px",
    fontSize: "18px",
    fontWeight: 500,
    textAlign: "center",
    color: "#333333"
  },
  "@bp4": {
    "h2": {
      marginTop: "6vh"
    },
    "p": {
      marginTop: "2vh",
      width: "40%"
    },
    "h3": {
      marginTop: "6vh",
      fontSize: "22px"
    }
  }
});

const WrapperContent = styled("div", {
  padding: "50px",
  position: "relative",
  "&::before,  &::after": {
    content: "",
    backgroundImage: `url("${ArrowIcons}")`,
    backgroundRepeat: "no-repeat",
    backgroundSize: "contain",
    display: "block",
    position: "absolute",
    width: "160px",
    height: "220px"
  },
  "&::before": {
    left: "5%",
    top: "-25px",
    transform: "rotate(225deg)",
    "@bp4": {
      left: "10%",
      top: "0"
    }
  },
  "&::after": {
    right: "5%",
    bottom: "-70px",
    transform: "rotate(45deg)",
    "@bp4": {
      right: "10%",
      bottom: "0"
    }
  },
  "@bp4": {
    "&::before": {
      top: "50%",
      left: "15%",
      transform: "translateY(-50%) rotate(180deg)"
    },
    "&::after": {
      top: "50%",
      right: "15%",
      transform: "translateY(-50%)"
    }
  }
});
const Header = styled("h1", {
  fontSize: "28px",
  textAlign: "center",
  "@bp4": {
    fontSize: "54px"
  },
  "> span": {
    display: "block",
    color: "$primary"
  }
})
const FooterMsg = styled("p", {
  textAlign: "center",
  fontWeight: 800,
  "> span": {
    display: "block",
    color: "$primary"
  }
});
const SimilarProjectsWrap = styled("div", {
  display: "flex",
  flexDirection: "column",
  justifyContent: "center",
  backgroundColor: "#e5e5e5",
  padding: "33px 16px 40px 16px",
  "@bp4": {
    padding: "40px 84px 118px 84px"
  }
});
const WrapperProjects = styled("div", {
  width: "97%",
  display: "flex",
  flexDirection: "row",
  overflowX: "scroll",
  flexGrow: 1,
  "& > div": {
    margin: "20px",
    minWidth: "75%",
    minHeight: "300px"
  },
  "h5": {
    fontSize: "13px !important",
    margin: "8px 15px !important"
  },
  "@bp4": {
    width: "100%",
    marginRight: "0",
    justifyContent: "space-around",
    overflowX: "hidden",
    "& > div": {
      minWidth: "30%",
      width: "30%"
    }
  }
});

export default PaymentSuccess;
